import React, {Component, PropTypes} from 'react'
import ClientSideCacheController from '../ClientSideCacheController';
import Cannonicalize from '../Cannonicalize';
import {ResponsiveContainer,AreaChart,XAxis,YAxis,CartesianGrid,Tooltip,Area} from 'recharts'
class WindChart extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate;
    this.state = {
      hourly: []
    }
  }



  componentWillMount() {
    try {
      this.setState(Cannonicalize.forecast(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      console.log('Wind Chart got bad forecast data from FRN_ ', e)
    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('forecast').then((data) => {
      this.setState(data)
    })
  }
  toolTip(props){

    if(!props.active)
      return null
    return (
      <div className='tool-tip'>
        <div className='text-center'>
          <b>{props.payload[0].payload.shortTime}</b>
        </div>
        <span>{props.payload[0].payload.wnd_spd_mph} mph {props.payload[0].payload.wnd_dir}</span>
      </div>
    )
  }

  render() { // REQUIRED
    if(this.state.hourly.length < 1)
      return null
    return (
      <div className='gnm-wind-chart hidden-xs hidden-sm'>
        <h5 className='white-at-small'>24hr Wind Speed Forecast for {this.state.city}, {this.state.state}</h5>
        <ResponsiveContainer width='100%' height={220}>
          <AreaChart data={this.state.hourly.slice(0,24)}
            margin={{ top: 20, left: -20, bottom: 0 }}>
            <XAxis dataKey="shortTime" />
            <YAxis />
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip content={this.toolTip} />
            <Area type="linear" dataKey="wnd_spd_mph" stroke="rgb(110,150,209)" fillOpacity={0.3} fill="rgb(108,150,210)" dot={false} activeDot={false}/>

          </AreaChart>
        </ResponsiveContainer>

      </div>
    )
  }
}

export default WindChart



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WindChart/index.js